import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from '../Modal/Modal'
import { GET_ALL_MERGE_CODES } from 'requests'
import Portal from 'components/Portal/Portal'
import ReactMarkdown from 'components/Markdown/Markdown'
import PropTypes from 'prop-types'

export default class TextEditor extends Component {
  static propTypes = {
    text: PropTypes.string,
    name: PropTypes.string,
    buttonLabel: PropTypes.node,
    placeholder: PropTypes.string,
    allowMergeCodes: PropTypes.bool,
    save: PropTypes.func,
  }
  constructor(props) {
    super()
    this.state = {
      modalOpen: false,
      text: props.text,
      mergeModalOpen: false,
      cursorPosition: 0,
      mergeCodes: false,
    }
  }
  caretStart = 0
  caretEnd = 0
  componentWillReceiveProps = (nextProps) => {
    if (this.props.text !== nextProps.text) {
      this.setState({ text: nextProps.text })
    }
  }
  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }
  handleChange = (e) => {
    this.setState({ text: e.target.value })
  }
  save = () => {
    this.props.onSave(this.props.name, this.state.text)
  }
  cancel = () => {
    this.setState({ text: this.props.text })
  }
  openMergeModal = () => {
    this.fetchMergeCodes()
    this.setState({
      mergeModalOpen: true,
      cursorPosition: this.textarea.selectionEnd,
    })
  }
  closeMergeModal = () => {
    this.setState({ mergeModalOpen: false })
  }
  insertMergeCode = (code) => {
    this.mergeModal.closeModal()
    this.setState((state) => ({
      text: `${state.text.slice(0, state.cursorPosition)}{{${code}}}${state.text.slice(
        state.cursorPosition
      )}`,
    }))
  }
  fetchMergeCodes = () => {
    if (!this.state.mergeCodes) {
      GET_ALL_MERGE_CODES((mergeCodes) => {
        // console.log(mergeCodes);
        this.setState({ mergeCodes })
      })
    }
  }
  cacheSelection = (e) => {
    this.caretStart = e.target.selectionStart
    this.caretEnd = e.target.selectionEnd
  }
  indentLine = () => {
    const text = this.state.text
    let firstReturn = text.slice(0, this.caretStart).lastIndexOf('\n')
    if (firstReturn < 0) firstReturn = 0
    const returnIndicies = Array.from(
      text.slice(this.caretStart, this.caretEnd).matchAll(/\n/g)
    ).map((group) => group.index + this.caretStart)
    returnIndicies.unshift(firstReturn)
    returnIndicies.unshift(0)
    const parts = returnIndicies.map((index, i) => {
      let nextIndex = returnIndicies[i + 1] !== undefined ? returnIndicies[i + 1] : text.length - 1
      if (index === nextIndex) {
        return ''
      } else {
        return text.slice(index === 0 ? 0 : index + 1, nextIndex + 1)
      }
    })
    const indentedText = parts.join('\t\t')
    this.setState({
      text: indentedText,
    })
  }
  render() {
    const { buttonLabel, placeholder, allowMergeCodes } = this.props
    return (
      <div className="block-wrapper">
        <button className="attribute-button" onClick={this.toggleModal}>
          {buttonLabel}
        </button>
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            title={buttonLabel}
            closeModal={this.toggleModal}
            modalSize="large"
            saveAndCloseButton={true}
            cancelButton={true}
            save={this.save}
            cancel={this.cancel}
          >
            <div className="text-editor-wrapper">
              <div className={`left-wrapper merge-codes`}>
                <div className="toolbar">
                  <button className="btn btn-primary" onClick={this.indentLine}>
                    Indent
                  </button>
                  {allowMergeCodes && (
                    <button className="btn btn-primary" onClick={this.openMergeModal}>
                      Insert Merge Code
                    </button>
                  )}
                </div>
                <textarea
                  ref={(r) => {
                    this.textarea = r
                  }}
                  className="text-editor"
                  value={this.state.text}
                  onChange={this.handleChange}
                  onSelect={this.cacheSelection}
                  placeholder={placeholder}
                />
                <MarkdownHint />
              </div>
              <div className="right-wrapper">
                <ReactMarkdown source={this.state.text} className="markdown" />
              </div>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={this.state.mergeModalOpen && this.state.mergeCodes ? true : false}>
          <Modal
            title="Insert Merge Code"
            ref={(r) => {
              this.mergeModal = r
            }}
            closeModal={this.closeMergeModal}
            modalSize="small"
            autoHeight
            closeButton
          >
            <MergeCodeList mergeCodes={this.state.mergeCodes} onSelection={this.insertMergeCode} />
          </Modal>
        </Portal>
      </div>
    )
  }
}

export const MarkdownHint = () => (
  <div className="hint">
    <span>
      _<i>italic</i>_
    </span>
    <span>
      **<b>bold</b>**
    </span>
    <span># Heading</span>
    <span>- List</span>
    <span>1. Ordered List</span>
    <span>[Link Text](URL)</span>
    <span>[{'>>>'}Redirect Link](URL)</span>
    <span>{'>'} Blockquote</span>
    <span>--- horizontal rule</span>
    <a href="http://commonmark.org/help/" target="_blank">
      ...More
    </a>
  </div>
)

export const allowedMergeFieldTypes = [
  'text',
  'textArea',
  'checkbox',
  'date',
  'DateRange',
  'radio',
  'select',
  'confirmFields',
  'FullName',
  'NameOrg',
  'dependentRadio',
  'dependentSelect',
  'LocalSelect',
  'dependentCheck',
  'serverSelect',
  'serverRadio',
  'paragraph',
  'FormationLocale',
  'MultiComplete',
  'ServerMultiComplete',
  'EFSCropPicker',
]
class MergeCodeList extends React.Component {
  render() {
    const { mergeCodes = [], onSelection, fields } = this.props
    return (
      <div className="merge-code-list">
        {mergeCodes.map((code, i) => (
          <MergeCode {...code} onClick={onSelection} key={i} />
        ))}
        {fields.map((field) => (
          <MergeCode
            CODE={field.name}
            LABEL={field.label || '[Unlabeled Field]'}
            onClick={(code) => onSelection(`FIELD:${code}`)}
            key={field.fieldId}
          />
        ))}
      </div>
    )
  }
}
MergeCodeList = connect((state) => {
  const fields = Object.values(state.designer.wizard.fields).filter((field) =>
    allowedMergeFieldTypes.includes(field.type)
  )
  return {
    fields,
  }
})(MergeCodeList)

const MergeCode = ({ CODE, LABEL, onClick }) => (
  <button
    className="merge-code"
    onClick={() => {
      onClick(CODE)
    }}
  >
    <span className="label">{LABEL}</span>
    <span className="code">{CODE}</span>
  </button>
)



// WEBPACK FOOTER //
// ./src/components/Designer2/TextEditor.js